import { Component, inject } from '@angular/core';
import { UtilityService } from '@core/services/utility.service';
import { NavbarClockInService } from '@core/services/navbar-clock-in.service';
import { EmployeeInfoService } from '@core/services/employee-info.service';

@Component({
    selector: 'app-navbar-clock-in',
    templateUrl: './navbar-clock-in.component.html',
    styleUrl: './navbar-clock-in.component.scss',
    standalone: false
})
export class NavbarClockInComponent {
  private employeeInfo = inject(EmployeeInfoService).getEmployeeInfo();
  public readonly navbarClockInService = inject(NavbarClockInService);
  private utilityService = inject(UtilityService);

  public readonly dateFormat = this.utilityService.getDateFormat().toLowerCase().replace('mm', 'MM') + ' h:mm:ss a';

  mealBreakEvent(event: Event): void {
    event.stopPropagation();
  }
}
